import { render, staticRenderFns } from "./LinksGenerator.vue?vue&type=template&id=96652a52&scoped=true"
import script from "./LinksGenerator.vue?vue&type=script&lang=js"
export * from "./LinksGenerator.vue?vue&type=script&lang=js"
import style0 from "./LinksGenerator.vue?vue&type=style&index=0&id=96652a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96652a52",
  null
  
)

export default component.exports